import React, { useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from "@fullcalendar/list";
import { Box, useTheme, Button } from "@mui/material";
import { tokens } from "../../../theme";
import AssignBulkShifts from "./AssignBulkShifts";
import HeaderShift from "./HeaderShift";
import AddIcon from "@mui/icons-material/Add";

function ShiftRoster() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [currentEvents, setCurrentEvents] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false); 

  const handleDateClick = (selected) => {
    // const title = prompt("Please enter a new title for your event");
    // const calendarApi = selected.view.calendar;
    // calendarApi.unselect();

    // if (title) {
    //   calendarApi.addEvent({
    //     id: `${selected.dateStr}-${title}`,
    //     title,
    //     start: selected.startStr,
    //     end: selected.endStr,
    //     allDay: selected.allDay,
    //   });
    // }
    setIsModalOpen(true);
  };

    const handleModalClose = () => {
    setIsModalOpen(false); // Close the modal
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };
  const handleEventClick = (selected) => {
    if (
      window.confirm(
        `Are you sure you want to delete the event '${selected.event.title}'`
      )
    ) {
      selected.event.remove();
    }
  };

  return (
    <Box>
      <HeaderShift />
      <Box sx={{ margin: "20px 0 5px 2px" }}>
        <Button
          onClick={handleOpenModal}
          startIcon={<AddIcon />}
          sx={{
            backgroundColor: "#1d82f5",
            "&:hover": { backgroundColor: "orange" },
            textAlign: "center",
            padding: "10px",
            marginLeft: "10px",
            height: "40px",
            color: "#fff",
            textTransform: "none",
            fontSize: "15px",
            fontFamily: "sans-serif",
          }}
        >
          Assign Bulk Shifts
        </Button>
      </Box>
      <AssignBulkShifts open={isModalOpen} onClose={handleModalClose}  />

      <Box flex="1 1 100%" ml="2px" sx={{ background: "#fff", color: "#000" }}>
        <FullCalendar
          height="75vh"
          plugins={[
            dayGridPlugin,
            timeGridPlugin,
            interactionPlugin,
            listPlugin,
          ]}
          headerToolbar={{
            left: "prev,next today",
            center: "title",
            right: "",
          }}
          initialView="dayGridWeek"
          editable={true}
          selectable={true}
          selectMirror={true}
          dayMaxEvents={true}
          select={handleDateClick}
          eventClick={handleEventClick}
          eventsSet={(events) => setCurrentEvents(events)}
        />
      </Box>
    </Box>
  );
}

export default ShiftRoster;
